import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Pie legal presente en toda la app y la landing (LSSI-CE): titular + enlaces a los 4 documentos.
export function LegalFooter() {
  const { t } = useTranslation();
  return (
    <footer className="legal-footer" data-testid="legal-footer">
      <span className="muted small">HUECO by Agentik · VRTC CONSULTORIA SL</span>
      <nav className="legal-footer-nav">
        <Link to="/aviso-legal" data-testid="foot-aviso">{t('landing.aviso_legal')}</Link>
        <Link to="/terminos" data-testid="foot-terminos">{t('landing.terminos')}</Link>
        <Link to="/privacidad" data-testid="foot-privacidad">{t('landing.privacidad')}</Link>
        <Link to="/cookies" data-testid="foot-cookies">{t('landing.cookies')}</Link>
      </nav>
    </footer>
  );
}
